import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

const BASE_URL = `/advertisement`;

const AdvertisementService = {
    createAdvertisement: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/createAdvertisement`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    getAdvertisement: (params?: any): Promise<AxiosResponse> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search
        };
        return instanceAxios.post(`${BASE_URL}/getAdvertisement`, queryParams);
    },

    deleteAdvertisement: (id: string): Promise<AxiosResponse> => {
        return instanceAxios.delete(`${BASE_URL}/deleteAdvertisement/${id}`);
    },

    getOneAdvertisement: (deck_id: string): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/getOneAdvertisement/${deck_id}`);
    },

    updateAdvertisement: (_id: string, data: any): Promise<AxiosResponse> => {
        return instanceAxios.put(`${BASE_URL}/updateAdvertisement/${_id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
};

export default AdvertisementService;